
<p-treeTable
[value]="reportCompanyAppTree"
*ngIf="showCompanyApp">
    <ng-template pTemplate="header">
        <tr>
            <th>{{ 'common.companies' | translate }}</th>
            <th>{{ 'common.applications' | translate }}</th>
            <th>{{ 'companyApplications.msBaseUrl' | translate }}</th>
            <th>{{ 'promotion.userId' | translate }}</th>
            <th>{{ 'userForm.login' | translate }}</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
        <tr [ttSelectableRow]="rowNode">
            <td>
                <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                {{rowData.company}}
            </td>
            <td>{{rowData.application}}</td>
            <td>{{rowData.ms_base_url}}</td>
            <td>{{rowData.id_user}}</td>
            <td>{{rowData.login}}</td>
        </tr>
    </ng-template>
</p-treeTable>

<p-treeTable
[value]="reportUserCompanyAppTree"
*ngIf="showUserCompanyApp">
    <ng-template pTemplate="header">
        <tr>
            <th>{{ 'userForm.login' | translate }}</th>
            <th>{{ 'promotion.userId' | translate }}</th>
            <th>{{ 'common.role' | translate }}</th>
            <th>{{ 'common.companies' | translate }}</th>
            <th>{{ 'common.applications' | translate }}</th>
            <th>{{ 'report.appDescription' | translate }}</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
        <tr [ttSelectableRow]="rowNode">
            <td>
                <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                {{rowData.login}}
            </td>
            <td>{{rowData.id_user}}</td>
            <td>{{rowData.role_description}}</td>
            <td>{{rowData.company}}</td>
            <td>{{rowData.application}}</td>
            <td>{{rowData.application_description}}</td>
        </tr>
    </ng-template>
</p-treeTable>


<p-treeTable
[value]="reportUserRolesTree"
*ngIf="showUserRoles">
    <ng-template pTemplate="header">
        <tr>
            <th>{{ 'promotion.userId' | translate }}</th>
            <th>{{ 'userForm.login' | translate }}</th>
            <th>{{ 'userForm.email' | translate }}</th>
            <th>MS</th>
            <th>{{ 'common.id_rule' | translate }}</th>
            <th>{{ 'common.description' | translate }}</th>
            <th>{{ 'common.application' | translate }}</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
        <tr [ttSelectableRow]="rowNode">
            <td>
                <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                {{rowData.id_user}}
            </td>
            <td>{{rowData.login}}</td>
            <td>{{rowData.email}}</td>
            <td>{{rowData.ms}}</td>
            <td>{{rowData.role_id}}</td>
            <td>{{rowData.descr}}</td>
            <td>{{rowData.application_name}}</td>
        </tr>
    </ng-template>
</p-treeTable>

<p-treeTable
[value]="reportRolesPermissionTree"
*ngIf="showRolesPermission">
    <ng-template pTemplate="header">
        <tr>
            <th>{{ 'dictionaryOperation.company_id' | translate }}</th>
            <th>MS</th>
            <th>{{ 'common.id_rule' | translate }}</th>
            <th>{{ 'common.description' | translate }}</th>

            <th>Operation ID</th>
            <th>Operation</th>
            <th>{{ 'permissionForm.type' | translate }}</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
        <tr [ttSelectableRow]="rowNode">
            <td>
                <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                {{rowData.company_id}}
            </td>
            <td>{{rowData.ms}}</td>
            <td>{{rowData.role_id}}</td>
            <td>{{rowData.descr}}</td>
            <td>{{rowData.operation_id}}</td>
            <td>{{rowData.operation}}</td>
            <td>{{rowData.type}}</td>
        </tr>
    </ng-template>
</p-treeTable>



// WEBPACK FOOTER //
// ./src/app/views/administration/report-user/view-report/view-report.component.html